const pt = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'Estou aprendendo <br />com Super Chinese. Aprende comigo!',
	'零基础任性学': 'Aprende desde nível zero',
	'听说读写全面提升': 'Melhora as suas habilidades de escutar, leitura, escritura e de fala',
	'趣味对话': 'Conversas divertidas',
	'100+日常对话等你来': 'Más de 100 conversas diarias estão aquí para que as aprendas',
	'智能AI': 'Com tecnologia IA',
	'个性化学习推荐，由浅入深系统学': 'Experiências de aprendizagem personalizadas e sistemáticas para que aprendas melhor.',
	'趣味对话等你来': 'Com conversas divertidas que te estão esperando',
	'立即打开': 'Abrir',
	'我在SuperChinese<br />已累计学习{day}天': 'Estou usando Super Chinese<br />por <span>{day}</span> días',
	'我在SuperChinese<br />已连续学习{day}天': 'Estou usando Super Chinese<br />por <span>{day}</span> día(s)',
	'学习生词': 'Vocabulario',
	'学习语法': 'Gramática',
	'口语练习': 'Práctica oral',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>vêzes',
	'点击右上角的按钮,选择在浏览器中打开': 'Clique no botão no canto superior direito e selecione abrir no navegador',
	'邀请码': 'Código de convite',
	'用邀请码注册，参与抽大奖': 'convida novos usuários a registrarem e envíe o código de convite para participar no sorteio',
}
export default pt;